import React from "react";
// REDUX
import { useSelector } from "react-redux";
// ICONS DARK FORWARD SEQUENCE
import forwardDark from "../../../assets/icons/movingWalk/we-dark-forward.gif";
// ICONS DARK BACKWARD SEQUENCE
import backwardDark from "../../../assets/icons/movingWalk/we-dark-backward.gif";
// ICONS LIGHT FORWARD SEQUENCE
import forwardLight from "../../../assets/icons/movingWalk/we-light-forward.gif";
// ICONS LIGHT BACKWARD SEQUENCE
import backwardLight from "../../../assets/icons/movingWalk/we-light-backward.gif";
// ICONS STATUS
import iconDarkStopped from "../../../assets/icons/movingWalk/we-dark-stopped.svg";
import iconLightStopped from "../../../assets/icons/movingWalk/we-light-stopped.svg";
// INTERFACES
import { Usage } from "../../../flatbuffers/generated/usage/usage";
import { DeviceDirection } from "../../../types/DeviceDirection";
import { RootState } from "../../../app/store";

function MonitoringIconsMovingWalks({
  direction,
  iconSize = 40,
  mapViewClass = "",
}: {
  direction: DeviceDirection;
  iconSize?: number;
  mapViewClass?: string;
}) {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */

  // ************************************************ */
  // USE STATE VARIABLES **************************** */

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */
  const { theme } = useSelector((state: RootState) => state.home);

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // FUNCTIONS ************************************** */

  // ************************************************* */
  // USE EFFECT ************************************** */

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <div className={`${mapViewClass || ""}`}>
      {/** STOPPED   */}
      {direction === null && (
        <div>
          {(theme === "dark" || theme === "blue") && (
            <img src={iconDarkStopped} alt="" height={iconSize} width={iconSize} />
          )}
          {theme === "light" && (
            <img src={iconLightStopped} alt="" height={iconSize} width={iconSize} />
          )}
        </div>
      )}
      {/** BACKWARD  */}
      {direction === Usage.Forward && (
        <div>
          {(theme === "dark" || theme === "blue") && (
            <img src={backwardDark} alt="" height={iconSize} width={iconSize} />
          )}
          {theme === "light" && (
            <img src={backwardLight} alt="" height={iconSize} width={iconSize} />
          )}
        </div>
      )}
      {/** FORWARD  */}
      {direction === Usage.Backward && (
        <div>
          {(theme === "dark" || theme === "blue") && (
            <img src={forwardDark} alt="" height={iconSize} width={iconSize} />
          )}
          {theme === "light" && (
            <img src={forwardLight} alt="" height={iconSize} width={iconSize} />
          )}
        </div>
      )}
    </div>
  );
}

export default MonitoringIconsMovingWalks;
